import React, { useState, useEffect } from "react";
import moment from "moment";

const ServerLimitExceeded = () => {
  const [countdown, setCountdown] = useState(3600); // 1 hour in seconds
  const [isHovered, setIsHovered] = useState(false);

  useEffect(() => {
    const timer = setInterval(() => {
      setCountdown((prev) => (prev > 0 ? prev - 1 : 0));
    }, 1000);
    return () => clearInterval(timer);
  }, []);

  const formatTime = (seconds) => {
    const mins = Math.floor(seconds / 60);
    const secs = seconds % 60;
    return `${String(mins).padStart(2, "0")}:${String(secs).padStart(2, "0")}`;
  };

  const handleRetry = () => {
    window.location.reload();
  };

  const handleContactSupport = () => {
    window.open("mailto:support@secureflow.com", "_blank");
  };

  return (
    <div className="limit-card-wrapper">
      <div
        className={`limit-card ${isHovered ? "hovered" : ""}`}
        onMouseEnter={() => setIsHovered(true)}
        onMouseLeave={() => setIsHovered(false)}
      >
        {/* Status Badge */}
        <div className="status-badge">
          <span className="pulse-dot"></span>
          <span>System Alert</span>
        </div>

        {/* Icon */}
        <div className="limit-icon-container">
          <div className="limit-icon-ring">
            <i className="bi bi-exclamation-triangle-fill limit-icon"></i>
          </div>
          <div className="limit-icon-glow"></div>
        </div>

        {/* Content */}
        <h1 className="limit-title">Server Limit Exceeded</h1>
        <p className="limit-description">
          We've temporarily reached our processing capacity. Your request is
          important to us — please wait a moment or try again shortly.
        </p>

        {/* Stats Grid */}
        <div className="stats-grid">
          <div className="stat-item">
            <i className="bi bi-people-fill stat-icon"></i>
            <span className="stat-value">2,847</span>
            <span className="stat-label">Active Users</span>
          </div>
          <div className="stat-divider"></div>
          <div className="stat-item">
            <i className="bi bi-clock-history stat-icon"></i>
            <span className="stat-value">{formatTime(countdown)}</span>
            <span className="stat-label">Est. Wait Time</span>
          </div>
        </div>

        {/* Progress Bar */}
        <div className="progress-container">
          <div className="progress-track">
            <div
              className="progress-fill"
              style={{ width: `${((3600 - countdown) / 3600) * 100}%` }}
            ></div>
          </div>
          <span className="progress-text">System recovery in progress...</span>
        </div>

        {/* Actions */}
        <div className="limit-actions">
          <button className="btn btn-primary" onClick={handleRetry}>
            <i className="bi bi-arrow-clockwise"></i>
            <span>Retry Now</span>
          </button>
          <button className="btn btn-secondary" onClick={handleContactSupport}>
            <i className="bi bi-headset"></i>
            <span>Contact Support</span>
          </button>
        </div>

        {/* Footer Info */}
        <div className="limit-meta">
          <i className="bi bi-info-circle"></i>
          <span>
            Incident ID: <code>ERR-503-{moment().format("YYYYMMDD")}-X7K9</code>
          </span>
        </div>
      </div>
    </div>
  );
};

export default ServerLimitExceeded;
